import { Model } from '@vuex-orm/core';
import Locale from '@/models/Locale';
import Image from '@/models/Image';
import AwardImage from '@/models/AwardImage';
import OfferPdfPropertiesAPI from '@/api/OfferPdfPropertiesAPI';
import OfferPdfPropertiesConfiguration from '@/models/interfaces/OfferPdfPropertiesConfiguration';
import HeaderImage from '@/models/HeaderImage';
import Currency from '@/models/Currency';

export default class OfferPdfProperties extends Model {

    public static entity = 'offerPdfProperties';

    public static fields() {
        return {
            id: this.attr(null),
            companyInfo: this.string(''),
            introText: this.string(''),
            offerInformation: this.attr(''),
            paymentAndDelivery: this.attr(''),
            richtext: this.attr(''),
            imageSegment: this.attr(''),
            signature: this.string(''),
            footerColumn1: this.attr(''),
            footerColumn2: this.attr(''),
            footerColumn3: this.attr(''),
            footerColumn4: this.attr(''),
            locale: this.belongsTo(Locale, 'locale_id'),
            locale_id: this.attr(null),
            logo: this.belongsTo(Image, 'logo_id'),
            logo_id: this.attr(null),
            headerImages_id: this.attr([]),
            headerImages: this.hasManyBy(HeaderImage, 'headerImages_id'),
            awardImages_id: this.attr([]),
            awardImages: this.hasManyBy(AwardImage, 'awardImages_id'),
        };
    }

    public static async getAll() {
        let offerPdfProperties;
        try {
            offerPdfProperties = await OfferPdfPropertiesAPI.getAll();
        } catch (e) {
            return Promise.reject(e);
        }
        this.create({
            data: offerPdfProperties.data,
        });
        return Promise.resolve();
    }

    public static async getById(offerPdfPropertiesId: string) {
        let offerPdfProperties;
        try {
            offerPdfProperties = await OfferPdfPropertiesAPI.getById(offerPdfPropertiesId);
        } catch (e) {
            return Promise.reject(e);
        }
        this.insertOrUpdate({
            data: offerPdfProperties.data,
        });
        return Promise.resolve(offerPdfProperties);
    }

    public static async updateExisting(
        offerPdfPropertiesId: string,
        offerPdfPropertiesInfo: OfferPdfPropertiesConfiguration,
        offerConfigurationId?: string) {
        let offerPdfProperties;
        try {
            offerPdfProperties = await OfferPdfPropertiesAPI.update(
                offerPdfPropertiesId,
                offerPdfPropertiesInfo,
                offerConfigurationId);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(offerPdfProperties);
    }

    public static async createNew(
        offerPdfPropertiesInfo: OfferPdfPropertiesConfiguration,
        offerConfigurationId?: string) {
        let offerPdfProperties;
        try {
            offerPdfProperties = await OfferPdfPropertiesAPI.create(offerPdfPropertiesInfo, offerConfigurationId);
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(offerPdfProperties);
    }

    public static async deleteExisting(offerPdfPropertiesId: string) {
        try {
            await OfferPdfPropertiesAPI.delete(offerPdfPropertiesId);
        } catch (e) {
            return Promise.reject(e);
        }
        await OfferPdfProperties.delete(offerPdfPropertiesId);
        return Promise.resolve();
    }

    public id!: string;
    public companyInfo!: string;
    public introText!: string;
    public offerInformation!: string;
    public paymentAndDelivery!: string;
    public richtext!: string;
    public imageSegment!: string;
    public signature!: string;
    public footerColumn1!: string;
    public footerColumn2!: string;
    public footerColumn3!: string;
    public footerColumn4!: string;
    public locale!: Locale;
    public logo!: Image;
    public headerImages!: HeaderImage[];
    public awardImages!: AwardImage[];
}
